export class ResetState {
  static readonly type = '[DocumentViewer] Reset State';
  constructor() {}
}

export class SetCurrentDocument {
  static readonly type = '[DocumentViewer] Set Current Document';
  constructor(public document: any) {}
}

export class SetDocumentCollection {
  static readonly type = '[DocumentViewer] Set Document Collection';
  constructor(public collection: []) {}
}

export class SetCurrentReport {
  static readonly type = '[DocumentViewer] Set Current Report';
  constructor(public reportName: string, public objectCode: string, public criteria: any) {}
}

export class SetCurrentReportMode {
  static readonly type = '[DocumentViewer] Set Current Report Mode';
  constructor(public mode: boolean) {}
}

export class SetMergeDoc {
  static readonly type = '[DocumentViewer] Set Merge Doc';
  constructor(public docName: string, public objectCode: string, public criteria: any, public mergeDocFormat: string) {}
}

export class SetStaticDoc {
  static readonly type = '[DocumentViewer] Set Static Doc';
  constructor(public docName: string, public objectCode: string, public staticDocFormat: string) {}
}

export class SetDocViewerReportData {
  static readonly type = '[DocumentViewer] Set DocViewer Report Data';
  constructor(public rowData: any) {}
}

export class SetDocViewerReportCollectionConfig {
  static readonly type = '[DocumentViewer] Set DocViewer Report Collection Config';
  constructor(public collectionConfig: any) {}
}

export class SetDocViewerRestoreDataMode {
  static readonly type = '[DocumentViewer] Set DocViewer Restore Data Mode';
  constructor(public restore: boolean) {}
}

export class SetCurrentReportPage {
  static readonly type = '[DocumentViewer] Set Current Report Page';
  constructor(public reportName: string, public objectCode: string, public reportPage: any) {}
}

export class ResetDocViewerReportState {
  static readonly type = '[DocumentViewer] Reset DocViewer Report State';
  constructor() {}
}
